import DataGrid from 'app/components/DataGrid';
import classes from 'app/components/JobConfigTemplates/classes.module.scss';
import useJobConfigTemplates from 'app/hooks/useJobConfigTemplates';
import JobConfigTemplateModal from './JobConfigTemplateModal';

import {
  IMAGE_PRODUCT_TYPE,
  OVERLAY_PRODUCT_TYPE,
  KNOCKOUT_PRODUCT_TYPE,
} from 'app/utils/Constants';

const JobConfigTemplates = props => {
  const {
    resource,
    formIsOpen,
    currentRecord,
    onFormClose,
    onAdd,
    onEdit,
    onQuickAdd,
    onQuickEdit,
    onDataGridLoad,
    onFormSubmit,
    onDestroy,
    showFilters,
    getRowData
  } = useJobConfigTemplates();

  const productTypeOptions = [
    { label: 'Digital Image', value: IMAGE_PRODUCT_TYPE },
    { label: 'Overlay', value: OVERLAY_PRODUCT_TYPE },
    { label: 'Background Knockout', value: KNOCKOUT_PRODUCT_TYPE }
  ]

  const visibleOptions = [
    { label: 'Visible', value: 1 },
    { label: 'Not Visible', value: 0 }
  ]

  const header = 'Marketplace';
  const addButtonLabel = 'Add Product';
  const columnOrder = ['name', 'visible', 'product_type', 'description', 'instructions'];
  const visibleColumns = [].concat(columnOrder);

  const columnDefOverrides = [
    { field: 'created_at', formatType: 'date' },
    { field: 'updated_at', formatType: 'date' },
    { field: 'name', quickEdit: true },
    { 
      field: 'visible',
      valueType: 'boolean',
      quickEdit: true,
      inputType: 'select',
      inputOptions: visibleOptions
    },
    {
      field: 'product_type',
      headerName: 'Product Type',
      inputType: 'select',
      inputOptions: productTypeOptions,
      quickEdit: true,
      cellRenderer: params => {
        let data = params.data;
        if (data) {
          let productType = productTypeOptions.find(o => {
            return o.value === data.product_type;
          });
          let text = productType?.label;
          return <span className={classes.cell}>{text}</span>;
        }
        return '';
      }
    },
    { field: 'instructions', headerName: 'How to use this product'  }
  ]

  const actions = [
    { key: 'destroy', label: 'Delete Products', callback: onDestroy }
  ]

  return (
    <div>
      <DataGrid
        resource={resource}
        header={header}
        getRowData={getRowData}
        addButtonLabel={addButtonLabel}
        onAdd={onAdd}
        showEdit={true}
        onEdit={onEdit}
        showQuickEdit={true}
        columnOrder={columnOrder}
        visibleColumns={visibleColumns}
        columnDefOverrides={columnDefOverrides}
        loadingMessage="Loading products..."
        showSelect={true}
        actions={actions}
        showFilters={showFilters}
        onDataGridLoad={onDataGridLoad}
      />
      <JobConfigTemplateModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        jobConfigTemplate={currentRecord}
        onFormSubmit={onFormSubmit}
        onDestroy={onDestroy}
      />
    </div>
  );
}

export default JobConfigTemplates;
